import Helper from '@ember/component/helper';

export default class IsStringNumberHelper extends Helper {
  compute([value]: [string | number | null | undefined]) {
    if (value === null || value === undefined) return false;

    const str = String(value).trim();

    if (str === '') return false;

    return !isNaN(Number(str)) && isFinite(Number(str));
  }
}
